import {makeStorageKey} from "./classes/printer-manager";

(function($){
    $.app = {}; //앱 네임스페이스

    /**
     * js 모듈 로드
     * 
     * @param js 로드할 모듈경로
     * @return void
     */
    $.app.load = function(js) {
        /*
        var once=js_url;//중복호출을 막기위한 스크립트 js 경로
        if($('script[src="'+js+'"]').length==0){ // 스크립트 중복삽입 체크
            $('script[src="'+once+'"]').eq(0).before('<script type="text/javascript" src="'+js+'" />');
        }//end if
*/
        if($('script[src="'+js+'"]').length==0){ // 스크립트 중복삽입 체크
            $('body').append('<script src="'+js+'" />');
        }//end if

    };

    /**
     * 지정된 url로 이동한다.
     *
     * @param url
     * @return void
     */
    $.app.move = function(url) {
        document.location.href = url;
    };

    /**
     * 한페이지 뒤로
     *
     * @return void
     */
    $.app.back = function() {
        history.back();
    };
    
    /**
     * 페이지 새로고침
     * 
     * @return void
     */
    $.app.refresh = function() {
        location.reload();
    };

    /**
     * 주어진 url 뒤에 QueryString을 추가한다.
     *
     * 새로 작성된 url의 맨뒤에오는 ? & 는 제거한다.
     *
     * @param url
     * @param add_query
     *      ex) 'a=1'
     *      ex) 'a=1&b=2'
     *      ex) 'a'
     *      ex) 'a=1&'
     *      ex) ''
     * @return url
     */
    $.app.url_add_query = function(url, add_query) {
        url = $.trim(url);
        add_query = $.trim(add_query);

        if (add_query) {
            add_query = add_query.replace((/^&/ig), '');//첫 & 제거

            if (url.indexOf("?") >= 0) { //문자내에 물음표있음.
                //url 마지막문자
                var last = url.match(/.$/ig)[0];

                if (last !== '?' && last!=='&') {
                    url += '&';
                }

            } else {
                url += '?';
            }

            url+=add_query;
        }

        //맨 마지막 ?& 제거
        url = url.replace((/[\?&]$/ig), '');

        return url;
    };


    //엘리먼트의 native event 안에서 호출되어 사용되는 함수모음.
    $.app.on_event = {};

    /**
     * native 이벤트의 arguments 를 받아서, jquery 이벤트 객체를 반환
     *
     *
     * @param source_args 이벤트리스너의 arguments
     * @return jquery 이벤트 객체
     */
    $.app.on_event.$event = function (source_args) {
        return event = new jQuery.Event( source_args[0] ); //이벤트 객체 jquery로 얻기
    };

    /**
     * 지정된 url로 이동한다.
     *
     * 사용 예 )
     *      <button onclick="$.app.on_event.move(arguments);" data-url="url"/>이동</button>
     *
     * 엘리먼트 옵션
     *      data-url : 이동할 url
     *      data-target
     *          - '_blank' : 새창
     *
     * @param source_args 이벤트리스너의 arguments
     * @return void
     */
    $.app.on_event.move = function (source_args) {

        var event = $.app.on_event.$event(source_args);
        var elem = $(event.currentTarget);
        event.stopImmediatePropagation();// 등록된 다음 이벤트를 실행하지 않음.
        event.preventDefault(); //엘리먼트의 기본 이벤트 동작방지 ( ex : a태그 클릭 )

        if (elem.data('target') == '_blank') {
            window.open(elem.data('url'), '_blank');
        } else {
            $.app.move(elem.data('url'));
        }
    };

    /**
     * 이벤트가 발생한 엘리먼트의 input 값으로, url 뒤에 querystring 을 추가해서 이동
     *
     * 정렬선택 / 몇개씩보기 선택 셀렉트박스에서 사용
     *
     * 엘리먼트 옵션
     *      data-url : 이동할 url
     *
     * @param source_args
     * @return void
     */
    $.app.on_event.move_with_self = function (source_args) {
        var $event = $.app.on_event.$event(source_args);
        var $elem = $($event.currentTarget);
        $event.stopImmediatePropagation();// 등록된 다음 이벤트를 실행하지 않음.
        $event.preventDefault(); //엘리먼트의 기본 이벤트 동작방지 ( ex : a태그 클릭 )

        // 쿼리스트링
        var query = '';
        if ($elem.is(':input')) {
            query = $elem.prop('name')+'='+$elem.val();
        }

        var url = $elem.data('url');
        url = $.app.url_add_query(url, query)
        //console.log(query);
        //console.log(url);
        $.app.move(url);
    };

    /**
     * 다운로드 처리
     * --------------------------
     * 단순 url 버튼 사용 예 )
     *      <button onclick="$.app.on_event.down(arguments);" data-url="url"/>다운로드</button>
     *
     * --------------------------
     * 입력값있는 다운로드 url 폼으로 사용한 예 )
     *      <form onsubmit="$.app.on_event.down(arguments);" data-url="url">
     *
     * -----------------------------------------------
     * init 콜백 )  : 아무 작업이 실행되지 않은 초기화 단계에서 호출, false 리턴으로 다운작업을 중단할 수 있음.
     *       <button data-init="callback"/>다운로드</button>
     *       <script> function callback($elemF) { return false; } <script>
     *
     * --------------------------------
     * 엘리먼트 옵션
     *      data-url : 다운할 url
     *      data-confirm-msg : 컨펌메세지 (등록안되면 컨펌처리안함)
     *
     * @param source_args
     * @return void
     */
    $.app.on_event.down = function (source_args) {
        var $event = $.app.on_event.$event(source_args);
        var $elem = $($event.currentTarget);
        $event.stopImmediatePropagation();// 등록된 다음 이벤트를 실행하지 않음.
        $event.preventDefault(); //엘리먼트의 기본 이벤트 동작방지 ( ex : a태그 클릭 )

        //init 콜백호출
        var init = window[$elem.data('init')];
        if ($.type(init) == 'function') {

            if (init($elem) === false) return;
        }

        var url = $elem.data('url');

        // 폼 인경우
        if ($elem.prop('tagName') == 'FORM') {
            var $form = $elem;
            url = $.app.url_add_query(url, $form.serialize());
        }



        //컨펌 처리
        var confirmMsg = $.trim($elem.data('confirmMsg'));
        if (confirmMsg) {
            if (! confirm(confirmMsg)) {
                return ;
            }
        }

        // iframe 추가
        var $iframe = $('<iframe style="display: none; height: 0">').prop('src', url);
        $('body').append($iframe);


    };


    /**
     * form 에 등록되어, 서브밋처리를 해준다.
     *
     *   - confirm 처리
     *   - 요소 검증처리
     *   등.. 폼서브밋 처리의 공통적인 작업을 처리한다.
     *
     * A ) form 엘리먼트의 서브밋이벤트에 등록하는 방법 외에,
     * B )  button 요소의 온클릭 이벤트에 사용될 수 있다.
     *
     * 사용 예 A)
     *      <form onsubmit="$.app.on_event.submit(arguments);">
     *
     * 사용 예 B)
     *      <form id="frm">
     *      <a onclick="$.app.on_event.submit(arguments);" data-form="#frm">
     *
     * -----------------------------------------------
     * 컨펌메세지 설정 )
     *       <form data-confirm-msg="메세지">
     *           
     * -----------------------------------------------
     * 히든변수 값 지정 - 버튼에 등록 )
     *       <form id="frm">
     *           <input type="hidden" name="id" value="">
     *       <a onclick="$.app.on_event.submit(arguments);" data-form="#frm" data-param-name="id" data-param-value="3425">
     *
     * -----------------------------------------------
     * 히든변수 값 지정 - 폼에 함수로 등록 )
     *       <form onsubmit="$.app.on_event.submit(arguments);" data-param-func="param_func">
     *           <input type="hidden" name="id" value="">
     *       <script> function param_func($elem, $form) {...} <script>
     *           
     * -----------------------------------------------
     * 히든변수 값 지정 - 버튼에 함수로 등록 )
     *       <form id="frm">
     *           <input type="hidden" name="id" value="">
     *       <a onclick="$.app.on_event.submit(arguments);" data-form="#frm" data-param-func="param_func">
     *       <script> function param_func($elem, $form) {...} <script>
     *
     * -----------------------------------------------
     * init-submit 콜백 )  : 기본변수만 세팅된 초기화 단계에서 호출, false 리턴으로 서브밋을 중단할 수 있음.
     *       <form data-init-submit="callback">
     *       <script> function callback($elem, $form) { return false; } <script>
     *
     * -----------------------------------------------
     * before-submit 콜백 - 폼 action 값 변경등에 사용 )  : 서브밋 바로 직전에 실행됨, false 리턴으로 서브밋을 중단할 수 있음.
     *       <form data-before-submit="callback">
     *       <script> function callback($elem, $form) { return false; } <script>
     *
     *
     * -----------------------------------------------
     * ajax 처리 : jquery ajax 옵션객체를 반환하는 콜백함수를 등록하면, 일반적인 폼서브밋 외에, ajax로 폼서브밋을 실행한다.
     *       <form data-ajax="callback" >
     *       <script>
     *           function callback() {
     *             return {
     *                  dataType: 'json',
     *                  succese: function () {},
     *                  error: function () {},
     *                  complete: function () {},
     *             };
     *          }
     *       <script>
     * -----------------------------------------------
     * ajax 실행 모듈(callback) 선택 : 지정된 콜백함수를 통해서, ajax 를 실행한다.값이 없으면 기본 $.ajax()를 통해서 실행한다.
     *                                  해당 콜백함수는 jquery ajax 옵션 배열을 인자로 받는다.
     *      <form data-ajax-module="callback" >
     *       <script>
     *           function callback(ajax) {
     *              // ... 전처리 ...
     *              $.ajax(ajax);
     *              // ... 후처리 ///
     *           }
     *       <script>
     * -----------------------------------------------
     *
     * 서브밋 버튼 엘리먼트 옵션
     *      data-form : 폼 엘리먼트 selector
     *
     * form 엘리먼트 옵션
     *      data-confirm-msg : 컨펌메세지 (등록안되면 컨펌처리안함)
     *
     * @param source_args 이벤트리스너의 arguments
     * @return void
     */
    $.app.on_event.submit = function (source_args) {

        var $event = $.app.on_event.$event(source_args);

        // 이벤트가 발생한 엘리먼트 선택
        var $elem = null;
        // 서브밋으로 발생한 이벤트인경우는 currentTarget 값이 없는 경우가 있음. target 속성으로도 가져옴.
        if ($event.type === 'submit' && $event.currentTarget === undefined) {
            $elem = $($event.target);
        } else {
            $elem = $($event.currentTarget);
        }


        //폼 엘리먼트 선택
        var $form = null;
        var cancel = null;
        var submit = null;
        var alert_cancel = function (msg) {
            alert(msg);
            cancel();
        };
        if ($elem.prop('tagName') === 'FORM') {
            $form = $elem;
            cancel = function () {
                $event.preventDefault(); //엘리먼트의 기본 이벤트 동작방지 ( 폼 서브밋 안함 )
                //console.log('cancel');
            };
            submit = function () {
            };
        } else {
            $form = $($elem.data('form'));
            $event.stopImmediatePropagation();// 등록된 다음 이벤트를 실행하지 않음.
            cancel = function () {
            };
            submit = function () {
                $form.submit();
            };
        }

        //init-submit 콜백호출
        var init_submit = window[$form.data('initSubmit')];
        if ($.type(init_submit) === 'function') {

            if (init_submit($elem, $form) === false) {
                return cancel();
            }
        }

        //히든변수 설정
        var param_name = $elem.data('paramName');
        if (param_name) {
            var param_val = $elem.data('paramValue');
            var hidden = $form.find('input[name="'+param_name+'"]').eq(0);
            if (hidden) {
                hidden.val(param_val);
            }
        }

        //변수설정 콜백호출
        var param_func = window[$elem.data('paramFunc')];
        if ($.type(param_func) === 'function') {
            param_func($elem, $form);
        }

        //컨펌 처리
        var confirmMsg = $.trim($form.data('confirmMsg'));
        if (confirmMsg) {
            if (! confirm(confirmMsg)) {
                return cancel();
            }
        }

        //before-submit 콜백호출
        var before_submit = window[$form.data('beforeSubmit')];
        if ($.type(before_submit) === 'function') {
            if (before_submit($elem, $form) === false) {
                return cancel();
            }
        }

        // 폼 서브밋처리
        if ($form.data('ajax') === undefined) {
            return submit();
        }

        cancel(); // 폼 기본 서브밋은 취소처리

        /** ajax 서브밋 처리 */
        var ajax = window[$form.data('ajax')];
        
        // 폼에 설정된 옵션
        var ajax_opts = {};
        if ($.type(ajax) === 'function') {
            ajax_opts = ajax();
        }

        // 필수 고정값 적용
        ajax_opts = $.extend(ajax_opts, {
            type: $form.prop('method')
            , url: $form.prop('action')
            ,data: $form.serializeArray()
        });//end ajax

        // ajax 실행모듈 선택
        var ajax_module = $form.data('ajaxModule');
        if (! ajax_module) {
            ajax_module = '$.ajax'; //기본모듈
        }
        $.app.util.call_func(ajax_module, window, ajax_opts);

        /** ajax 서브밋 처리 끝 */
    };




    // ajax 실행모듈 모음
    $.app.ajax = {};
    $.app.ajax.module = {};

    /**
     * 앱의기본 ajax 모듈
     *  - ajax 가 동시에 여러번 호출되지 않도록 제한
     *  - 로딩이미지 표시
     *  - 오류 얼럿처리
     * @param opts
     */
    $.app.ajax.module.default = function (opts) {
        //console.log(opts);

        // 기본값 적용
        var defaults = {
            dataType: 'json'
        };
        opts = $.extend(defaults,opts); //옵션적용

        /** 이벤트 콜백 처리 */
        var success_event = null;
        if(opts.success && $.type(opts.success)=='function'){ //함수로 등록된경우
            success_event=opts.success;
        }else if(opts.success && $.type(opts.success)=='string' && opts.success!=''){//문자열로 함수명 등록된경우
            success_event=window[opts.success];
        }//end if

        var error_event = null;
        if(opts.error && $.type(opts.error)=='function'){ //함수로 등록된경우
            error_event=opts.error;
        }else if(opts.error && $.type(opts.error)=='string' && opts.error!=''){//문자열로 함수명 등록된경우
            error_event=window[opts.error];
        }//end if

        var complete_event = null;
        if(opts.complete && $.type(opts.complete)=='function'){ //함수로 등록된경우
            complete_event=opts.complete;
        }else if(opts.complete && $.type(opts.complete)=='string' && opts.complete!=''){//문자열로 함수명 등록된경우
            complete_event=window[opts.complete];
        }//end if
        /** 이벤트 콜백 처리 끝 */

        /** 오류메세지 처리콜백 */
        let alert_error_msg = function (msg) {
            alert(msg);
        };
        if(opts.alert_error_msg && $.type(opts.alert_error_msg)=='function'){ //함수로 등록된경우
            alert_error_msg=opts.alert_error_msg;
        }else if(opts.alert_error_msg && $.type(opts.alert_error_msg)=='string' && opts.alert_error_msg!=''){//문자열로 함수명 등록된경우
            alert_error_msg=window[opts.alert_error_msg];
        }//end if
        /** 오류메세지 처리콜백  끝*/


        /** 고정값 적용 */
        opts = $.extend(opts,{

            success: function(response, textStatus, jqXHR){
                window.ajax_load_state='rest'; //ajax 상태 변경

                //success 콜백함수 실행
                if(success_event){
                    success_event(response, textStatus, jqXHR);
                }//end if
                //success 콜백함수 실행 끝
                

            }//end success

            ,error: function(jqXHR, textStatus, errorThrown){
                window.ajax_load_state='rest'; //ajax 상태 변경

                /**
                 * uikit 얼럿 다이얼로그로 띄우면,
                 * 기존에 다이얼로그창에서 호출된경우, ajax를 요청한 부모 다이얼로그가 종료되고 ,
                 * 얼럿 다이얼로그가 뜨기때문에, 얼럿 후에 기존에 작성해놨던 폼이 사라지는 문제가 있어서
                 * 일반 javascript 얼럿처리함.
                 */
                var msg = '';
                if (jqXHR.status === 500 && jqXHR.responseText){ // 애플리케이션에서 반환한 로직상 실패 응답인경우
                    msg = jqXHR.responseText;
                }else if(jqXHR.status === 404){
                    msg = '페이지를 찾을 수 없습니다';
                }else{
                    msg = "통신에 실패하였습니다. 다시 시도해주십시오.(status : "+jqXHR.status+", "+jqXHR.statusText+")";

                }//end if

                // 고넬로 오류코드
                let code = jqXHR.getResponseHeader('gonelo-error-code');
                if (code) {
                    code = parseInt(code);
                }

                // 오류내용 표시
                alert_error_msg(msg, code);


                //error 콜백함수 실행
                if(error_event){
                    error_event(jqXHR, textStatus, errorThrown);
                }//end if
                //error 콜백함수 실행 끝

            }//end error

            ,complete: function(jqXHR, textStatus){

                //complete 콜백함수 실행
                if(complete_event){
                    complete_event(jqXHR, textStatus);
                }//end if
                //complete 콜백함수 실행 끝
                
                // ajax 로딩중 제거
                $("#ajax-loading").hide();

            }//end complete
            
            ,beforeSend: function(){
                window.ajax_load_state='working'; //ajax 상태 변경
            }//end beforeSend
            
        });
        /** 고정값 적용 끝 */



        // ajax 로딩중
        $("#ajax-loading").show();

        $.ajax(opts);
    };

    /**
     * 백그라운드에서 조용하게 실행되는 ajax 모듈
     *  - ajax 가 동시에 여러번 호출되는 것을 제한하지 않음.
     *  - ajax 실행중에 화면 로딩 block 기능없음
     *  - 오류 얼럿처리
     * @param opts
     */
    $.app.ajax.module.background = function (opts) {
        //console.log(opts);

        // 기본값 적용
        var defaults = {
            dataType: 'json'
        };
        opts = $.extend(defaults,opts); //옵션적용

        /** 이벤트 콜백 처리 */
        var success_event = null;
        if(opts.success && $.type(opts.success)=='function'){ //함수로 등록된경우
            success_event=opts.success;
        }else if(opts.success && $.type(opts.success)=='string' && opts.success!=''){//문자열로 함수명 등록된경우
            success_event=window[opts.success];
        }//end if

        var error_event = null;
        if(opts.error && $.type(opts.error)=='function'){ //함수로 등록된경우
            error_event=opts.error;
        }else if(opts.error && $.type(opts.error)=='string' && opts.error!=''){//문자열로 함수명 등록된경우
            error_event=window[opts.error];
        }//end if

        var complete_event = null;
        if(opts.complete && $.type(opts.complete)=='function'){ //함수로 등록된경우
            complete_event=opts.complete;
        }else if(opts.complete && $.type(opts.complete)=='string' && opts.complete!=''){//문자열로 함수명 등록된경우
            complete_event=window[opts.complete];
        }//end if
        /** 이벤트 콜백 처리 끝 */

        /** 오류메세지 처리콜백 */
        let alert_error_msg = function (msg) {
            alert(msg);
        };
        if(opts.alert_error_msg && $.type(opts.alert_error_msg)=='function'){ //함수로 등록된경우
            alert_error_msg=opts.alert_error_msg;
        }else if(opts.alert_error_msg && $.type(opts.alert_error_msg)=='string' && opts.alert_error_msg!=''){//문자열로 함수명 등록된경우
            alert_error_msg=window[opts.alert_error_msg];
        }//end if
        /** 오류메세지 처리콜백  끝*/


        /** 고정값 적용 */
        opts = $.extend(opts,{

            success: function(response, textStatus, jqXHR){
                

                //success 콜백함수 실행
                if(success_event){
                    success_event(response, textStatus, jqXHR);
                }//end if
                //success 콜백함수 실행 끝
                

            }//end success

            ,error: function(jqXHR, textStatus, errorThrown){
                

                var msg = '';
                if (jqXHR.status === 500 && jqXHR.responseText){ // 애플리케이션에서 반환한 로직상 실패 응답인경우
                    msg = jqXHR.responseText;
                }else if(jqXHR.status === 404){
                    msg = '페이지를 찾을 수 없습니다';
                }else{
                    msg = "통신에 실패하였습니다. 다시 시도해주십시오.(status : "+jqXHR.status+", "+jqXHR.statusText+")";

                }//end if

                // 오류내용 표시
                alert_error_msg(msg);


                //error 콜백함수 실행
                if(error_event){
                    error_event(jqXHR, textStatus, errorThrown);
                }//end if
                //error 콜백함수 실행 끝

            }//end error

            ,complete: function(jqXHR, textStatus){

                //complete 콜백함수 실행
                if(complete_event){
                    complete_event(jqXHR, textStatus);
                }//end if
                //complete 콜백함수 실행 끝
                
            }//end complete
            
            ,beforeSend: function(){
                
            }//end beforeSend
            
        });
        /** 고정값 적용 끝 */


        $.ajax(opts);
    };

    // 팝업 모음
    $.app.popup = {};

    
    /**
     * 예상 출고운임
     *
     * ----------------------------------
     * 사용 예 )
     *      <button
     *          onclick="$.app.popup.expected_shipout_cost(arguments);"
     *          data-house-id="123"
     *      />
     *
     * ----------------------------------
     * 버튼 엘리먼트 옵션 )
     *      data-house-id : 하우스ID
     *
     * @param source_args
     * @return void
     */
    $.app.popup.expected_shipout_cost = function (source_args) {
        var $event = $.app.on_event.$event(source_args);
        var $elem = $($event.currentTarget);
        $event.stopImmediatePropagation();// 등록된 다음 이벤트를 실행하지 않음.
        $event.preventDefault(); //엘리먼트의 기본 이벤트 동작방지 ( ex : a태그 클릭 )

        var house_id = $elem.data('houseId');

        // 모듈 창
        var $div = $('#app-popup-expected-shipout-cost');

        // ajax 옵션
        var opts = {
            type: 'get',
            url: '/houses/'+house_id+'/expected-shipout-cost',
            data: {},
            dataType: 'html',

            success: function (response, textStatus, jqXHR) {
                var $res = $(response);

                // 삽입
                $div.html($res);

                // 모달 show
                UIkit.modal('#app-popup-expected-shipout-cost').show();
            }
        };

        // ajax 실행
        $.app.ajax.module.default(opts);

    };

    /**
     * 운임 상세보기
     *
     * ----------------------------------
     * 사용 예 )
     *      <button
     *          onclick="$.app.popup.shipping_cost_detail(arguments);"
     *          data-house-id="123"
     *      />
     *
     * ----------------------------------
     * 버튼 엘리먼트 옵션 )
     *      data-house-id : 하우스ID
     *
     * @param source_args
     * @return void
     */
    $.app.popup.shipping_cost_detail = function (source_args) {
        var $event = $.app.on_event.$event(source_args);
        var $elem = $($event.currentTarget);
        $event.stopImmediatePropagation();// 등록된 다음 이벤트를 실행하지 않음.
        $event.preventDefault(); //엘리먼트의 기본 이벤트 동작방지 ( ex : a태그 클릭 )

        var house_id = $elem.data('houseId');

        // 모듈 창
        var $div = $('#app-popup-shipping-cost-detail');

        // ajax 옵션
        var opts = {
            type: 'get',
            url: '/houses/'+house_id+'/shipping-cost',
            data: {},
            dataType: 'html',

            success: function (response, textStatus, jqXHR) {
                var $res = $(response);

                // 삽입
                $div.html($res);

                // 모달 show
                UIkit.modal('#app-popup-shipping-cost-detail').show();
            }
        };

        // ajax 실행
        $.app.ajax.module.default(opts);

    };

    /**
     * 하우스 검색 팝업 실행
     *
     * ----------------------------------
     * 사용 예 )
     *      <button
     *          onclick="$.app.popup.search_house(arguments);"
     *          data-form="#frm-search-house"
     *      />
     *
     *      <form
     *          id="frm-search-house"
     *          data-choice-callback="to_house_choice"
     *       >
     *          <input type="hidden" name="검색옵션" value="팝업 내 폼에 있는 검색값으로 대체가능 (재정의 가능)"/>
     *          <input type="hidden" data-fix name="검색옵션-고정" value="팝업 내 폼에 있는 검색값으로 대체불가능. (재정의 불가능)"/>
     *       </form>
     *
     *
     * ----------------------------------
     * 버튼 엘리먼트 옵션 )
     *      data-form : 메인폼 (jquery selector)
     *
     * 메인폼 옵션 )
     *      data-choice-callback : 배송 [선택] 버튼의 콜백함수 등록 (콜백함수명)
     *
     *                              function callback (
     *                                  house_id // 선택된 하우스ID
     *                              ) {
     *                                  return true; // 콜백실행 후 모달을 닫을지여부 (true : 닫음 , false : 안닫음)
     *                              }
     *
     *
     * @param source_args
     * @return void
     */
    $.app.popup.search_house = function (source_args) {
        var $event = $.app.on_event.$event(source_args);
        var $elem = $($event.currentTarget);
        $event.stopImmediatePropagation();// 등록된 다음 이벤트를 실행하지 않음.
        $event.preventDefault(); //엘리먼트의 기본 이벤트 동작방지 ( ex : a태그 클릭 )

        /**
         * 팝업 내 form 에서 함수가 실행된경우
         * $elem : 팝업 내 검색 폼
         * $form : 외부에 있는 메인 폼
         */
        var form_selector = $elem.data('form');
        var $form = $(form_selector); // 메인 폼

        // 옵션
        var choice_callback = $form.data('choiceCallback');

        // 메인폼에 파라메터 히든변수 생성
        var init_param = function (name) {
            if ($form.find('input[name="'+name+'"]').length == 0) {
                $form.append('<input type="hidden" name="'+name+'" val=""/>');
            }
        };
        init_param('region_id');
        init_param('agent_id');
        init_param('user_id');
        init_param('except_id');
        init_param('id');
        init_param('name');
        init_param('sp_code');
        init_param('unpacking');

        // 파라메터 재정의
        if ($elem.prop('tagName') == 'FORM') {
            var reclare_param = function (name) {
                var $p = $form.find('input[name="'+name+'"]');
                if ($p.data('fix') === undefined) {
                    $p.val($elem.find('input[name="'+name+'"]').val());
                }
            };
            reclare_param('region_id');
            reclare_param('agent_id');
            reclare_param('user_id');
            reclare_param('except_id');
            reclare_param('id');
            reclare_param('name');
            reclare_param('sp_code');
            reclare_param('unpacking');
        }
        var param = $form.serializeArray();



        // 검색실행 함수
        /**
         *
         * @param parameters 검색 파라메터
         */
        var search = function (parameters) {
            // 모듈 창
            var $div = $('#app-popup-search-house');

            // ajax 옵션
            var opts = {
                type: 'get',
                url: '/houses/search-popup',
                data: parameters,
                dataType: 'html',

                success: function (response, textStatus, jqXHR) {

                    var $res = $(response);

                    // 검색폼 초기화
                    $res.find('form.search-form').data('form', form_selector);

                    // 선택버튼 이벤트
                    $res.find('.choice-btn').on('click', function () {
                        var house_id = $(this).data('houseId');
                        if (choice_callback) {
                            var is_close = $.app.util.call_func(choice_callback, window, [house_id]);
                            if (is_close) UIkit.modal('#app-popup-search-house').hide();
                        }
                    });

                    // 페이지버튼 이벤트
                    $res.find('.uk-pagination').on('click', 'a.pager', function () {

                        //페이지 파라메터추가
                        var page = $(this).data('page');
                        var key = -1;
                        for (var i = 0; i < parameters.length; i++) {
                            if (parameters[i].name == 'page') {
                                key = i;
                                break;
                            }
                        }
                        if (key >= 0) {
                            parameters[key].value = page;
                        } else{
                            parameters[parameters.length] = {name: 'page', value: page};
                        }

                        // 페이지번호로 검색 실행
                        search(parameters);
                    });

                    // 삽입
                    $div.html($res);

                    // 모달 show
                    UIkit.modal('#app-popup-search-house').show();

                    //console.log(response);
                }
            };



            // ajax 실행
            $.app.ajax.module.default(opts);
        };

        // 검색 실행
        search(param);


    };

    // 프린트 관련
    $.app.print = {};


    let cacheReadyPrintManager = null;
    /**
     * 프린터출력 신규방식에 대한 준비가 되었는지 판단함
     * 각 지역별로 판단하며,
     * 현재 사용중인 PC에 `PrintManager/지역ID` 에 대한 로컬스토리지 설정이 세팅되었는지로 판단함.
     * 허용된 지역의 설정이 있다면, 신규방식을 사용하는것으로 판단
     * @returns bool
     */
    $.app.print.readyPrintManger = function () {
        // 캐시
        if (cacheReadyPrintManager !== null) {
            return cacheReadyPrintManager;
        }
        
        // 신규방식 허용지역 (TASK-081: 17 독일 켈스터바흐 추가 / TASK-142: 7 호주 브리즈번 추가 — 누락 시 구방식 direct.php(zpl) fallback 으로 ZPL 오류)
        let able_region_ids = [6, 7, 9, 10, 11, 12, 13, 15, 16, 17];

        // 설정값이 있는지여부
        let found = false;
        for (let i = 0; i < able_region_ids.length; i++) {
            let region_id = able_region_ids[i];
            let storage_key = makeStorageKey(region_id);
            if (localStorage.getItem(storage_key)) {
                found = true;
                break;
            }

        }

        cacheReadyPrintManager = found;
        return found;
    }
    console.log('readyPrintManager is ', $.app.print.readyPrintManger());


    /**
     * 운송장 라벨을 출력한다.
     *
     * 사용 예 )
     *      <button onclick="$.app.print.bl(arguments);" data-house-id="1" /><span class="text">출력</span></button>
     *
     * 엘리먼트 옵션
     *      data-house-id : 하우스ID
     *      data-blno : 프린트할 송장번호
     *      data-total-blnos : 전체송장번호 (컴마로 송장구분)
     *      data-package-amount : 패키지수량
     *                            - 값이 설정되면, 멀티패키지인 경우, 출력대신 송장선택 모달이 뜬다.
     *
     * @param source_args 이벤트리스너의 arguments
     * @return void
     */
    $.app.print.bl = function (source_args) {
        var $event = $.app.on_event.$event(source_args);
        var $elem = $($event.currentTarget);
        $event.stopImmediatePropagation();// 등록된 다음 이벤트를 실행하지 않음.
        $event.preventDefault(); //엘리먼트의 기본 이벤트 동작방지 ( ex : a태그 클릭 )

        var house_id = $elem.data('houseId');
        var blno = $elem.data('blno');

        // 패키지수량 모달
        var package_amount = $elem.data('packageAmount');
        if (package_amount && package_amount > 1) {
            var id = 'modal-print-bl-multi-packages';
            var $modal = $('#'+id);
            if ($modal.length === 0 ) {
                $modal = $(
                    '<div id="'+id+'" class="uk-flex-top" uk-modal>' +
                    '    <div class="uk-modal-dialog uk-margin-auto-vertical">' +
                    '       <div class="uk-modal-header">' +
                    '         <h2 class="uk-modal-title">라벨프린트 - Multi Packages</h2>' +
                    '       </div>' +
                    '       <div class="uk-modal-body uk-padding-remove" uk-overflow-auto>' +
                    '            <p class="uk-text-center">프린트할 송장을 선택하세요</p>' +
                    '            <ul class="uk-list uk-list-striped modal-list">' +
                    '            </ul>' +
                    '       </div>' +

                    '       <div class="uk-modal-footer uk-text-right">' +
                    '           <button class="uk-button uk-button-default uk-modal-close" type="button"><span uk-icon="icon: close"></span> 닫기</button>\n' +
                    '           <button ' +
                    '               class="uk-button uk-button-primary modal-btn-all" ' +
                    '               type="button"' +
                    '               onclick="$.app.print.bl(arguments);"' +
                    '               data-house-id=""' +
                    '               title="모든 송장을 프린트합니다"' +
                    '           >' +
                    '               <i class="material-icons" style="font-size: 24px; vertical-align: middle">print</i> PRINT ALL' +
                    '           </button>' +
                    '       </div>' +
                    '    </div>' +
                    '</div>'
                );
                $('body').append($modal);
            }



            // 송장 리스트
            var total_blnos = $elem.data('totalBlnos');
            total_blnos = total_blnos + ''; // 문자열로 형변환
            //console.log(total_blnos);
            var blnos_array = total_blnos.split(',');
            //console.log(blnos_array);

            var $list = $modal.find('.modal-list');
            $list.empty();
            for (var i =0; i < blnos_array.length; i++) {
                var blno = blnos_array[i];
                $list.append(
                    '<li>' + blno +
                    '   <button ' +
                    '       class="uk-button uk-button-default uk-button-small" ' +
                    '       type="button"' +
                    '       onclick="$.app.print.bl(arguments);"' +
                    '       data-house-id="'+house_id+'"' +
                    '       data-blno="'+blno+'"' +
                    '   >' +
                    '       <i class="material-icons" style="font-size: 18px; vertical-align: middle">print</i> PRINT BL' +
                    '   </button>' +
                    '</li>'
                );
            }


            // 전체출력 버튼
            var $btn_all = $modal.find('.modal-btn-all');
            $btn_all.data('houseId', house_id);

            // 모달 쇼
            UIkit.modal('#'+id).show();

            return ;
        }


        // 프린트중 변경
        /*
        var $text = $elem.find('span.text');
        var old_text = $text.text();
        $text.text('printing...');
        $elem.prop('disabled', true);
        */
        if ($.app.print.readyPrintManger()) {
            // 신규방식 사용
            let printer_api = app.printerApi();
            printer_api.printBl(null, house_id, blno).catch(alert);

            return;

        }

        // iframe
        var $ifr = $('<iframe style="display:none; height: 0"></iframe>');

        $('body').append($ifr); //바디에 등록
        var src = '/ext/qz-tray/direct.php?label_type=bl&house_id='+house_id;
        if (blno) {
            src += '&blno='+blno;
        }
        $ifr.prop('src', src);// 페이지 로딩

        // 프린트중 해지
        /*
        $text.text(old_text);
        $elem.prop('disabled', false);
        */
    };


    /**
     * 운송장 라벨을 zpls 배열을 직접 넘겨서 출력한다.
     * iframe 에 여러개의 zpl 을 한번에넘겨서 출력하기 위한용도로 제작됨.  (송장 일괄 출력)
     *
     * @param  zpls javascript 배열로 넘어온다
     * @return void
     */
    $.app.print.label_by_zpls = function (zpls) {
        // json 변환
        //console.log('-----------------------------');
        //console.log(zpls);
        let zpls_json = JSON.stringify(zpls);
        //console.log(zpls_json);

        // iframe
        let $ifr = $('iframe.label_by_zpls');
        if ($ifr.length === 0) {
            $ifr = $('<iframe class="label_by_zpls" name="label_by_zpls" style="display: block; height: 0"></iframe>');
            $('body').append($ifr); //바디에 등록
        }
        // form
        let $form = $('form.label_by_zpls');
        if ($form.length > 0) {
            $form.remove();
        }
        $form = $('<form class="label_by_zpls"></form>');
        $form.prop('method', 'post');
        $form.prop('action', '/ext/qz-tray/label_by_zpls.php');
        $form.prop('target', 'label_by_zpls');
        let $input = $('<input type="hidden" name="zpls"/>');
        $input.val(zpls_json);
        $form.append($input);
        $('body').append($form); //바디에 등록

        // 서브밋
        $form.submit();
    };

    /**
     * 출고보류 라벨을 출력한다.
     *
     * 사용 예 )
     *      <button onclick="$.app.print.shipout_hold_label(arguments);" data-house-id="1" /><span class="text">출력</span></button>
     *
     * 엘리먼트 옵션
     *      data-house-id : 하우스ID
     *
     * @param source_args 이벤트리스너의 arguments
     * @return void
     */
    $.app.print.shipout_hold_label = function (source_args) {
        var $event = $.app.on_event.$event(source_args);
        var $elem = $($event.currentTarget);
        $event.stopImmediatePropagation();// 등록된 다음 이벤트를 실행하지 않음.
        $event.preventDefault(); //엘리먼트의 기본 이벤트 동작방지 ( ex : a태그 클릭 )

        var house_id = $elem.data('houseId');

        if ($.app.print.readyPrintManger()) {
            // 신규방식 사용
            let printer_api = app.printerApi();
            printer_api.printShipoutHoldLabel(null, house_id).catch(alert);

            return;

        }

        // iframe
        var $ifr = $('<iframe style="display:none; height: 0"></iframe>');

        $('body').append($ifr); //바디에 등록
        var src = '/ext/qz-tray/direct.php?label_type=shipout-hold-label&house_id='+house_id;

        $ifr.prop('src', src);// 페이지 로딩
    };


    /**
     * 보관상품 라벨을 출력한다.
     *
     * 사용 예 )
     *      <button onclick="$.app.print.store_label(arguments);" data-prod-id="1" /><span class="text">출력</span></button>
     *
     * 엘리먼트 옵션
     *      data-prod-id : 상품ID
     *
     * @param source_args 이벤트리스너의 arguments
     * @param prod_id 상품번호 (명시적으로 넘겨줄경우, 엘리먼트에 설정된 data값을 사용하지 않는다.,
     *                엘리먼트에 설정된 data값은 jquery $.data함수 캐시처리 문제로 동적으로 변경되는 값을 가져올때 문제가 있을 수 있음.)
     * @return void
     */
    $.app.print.store_label = function (source_args, prod_id) {
        var $event = $.app.on_event.$event(source_args);
        var $elem = $($event.currentTarget);
        $event.stopImmediatePropagation();// 등록된 다음 이벤트를 실행하지 않음.
        $event.preventDefault(); //엘리먼트의 기본 이벤트 동작방지 ( ex : a태그 클릭 )

        // 상품번호
        if (! prod_id) {
            prod_id = $elem.data('prodId');
        }

        if ($.app.print.readyPrintManger()) {
            // 신규방식 사용
            let printer_api = app.printerApi();
            printer_api.printStoreLabel(null, prod_id).catch(alert);

            return;

        }

        // iframe
        var $ifr = $('<iframe style="display:none; height: 0"></iframe>');

        $('body').append($ifr); //바디에 등록
        var src = '/ext/qz-tray/direct.php?label_type=store-label&prod_id='+prod_id;

        $ifr.prop('src', src);// 페이지 로딩
    };

    /**
     * 입고라벨을 출력한다.
     *
     * 사용 예 )
     *      <button onclick="$.app.print.ship_in_label(arguments);" data-ship-in-id="1" /><span class="text">출력</span></button>
     *
     * 엘리먼트 옵션
     *      data-ship-in-id : 입고내역ID
     *
     * @param source_args 이벤트리스너의 arguments
     * @return void
     */
    $.app.print.ship_in_label = function (source_args) {
        var $event = $.app.on_event.$event(source_args);
        var $elem = $($event.currentTarget);
        $event.stopImmediatePropagation();// 등록된 다음 이벤트를 실행하지 않음.
        $event.preventDefault(); //엘리먼트의 기본 이벤트 동작방지 ( ex : a태그 클릭 )

        var ship_in_id = $elem.data('shipInId');

        // iframe
        var $ifr = $('<iframe style="display:none; height: 0"></iframe>');

        $('body').append($ifr); //바디에 등록
        var src = '/ext/qz-tray/direct.php?label_type=ship-in-label&ship_in_id='+ship_in_id;

        $ifr.prop('src', src);// 페이지 로딩
    };

    // util모음
    $.app.util = {};

    /**
     * 함수이름 문자열로 함수를 호출한다.
     * -----------------------------------------
     * 사용 예 )
     *      $.app.util.call_func(ajax_module, window, ajax_opts);
     * -----------------------------------------
     *
     * @param functionName 함수이름 (네임스페이스가능)
     * @param context (실행할 컨텍스트, 기본적으로 window 를 주면 최상위부터 네임스페이스 적용한다.
     *
     */
    $.app.util.call_func = function (functionName, context /*, args */) {
        var args = [].slice.call(arguments).splice(2);
        var namespaces = functionName.split(".");
        var func = namespaces.pop();
        for(var i = 0; i < namespaces.length; i++) {
            context = context[namespaces[i]];
        }
        return context[func].apply(context, args);
    }


    /**
     * flatpickr 날짜 입력 초기화
     * - 달력 팝업 + 직접 타이핑 지원
     * - 20260101 입력 → 2026-01-01 자동 변환
     * - 2026-01-01 입력 → 유지
     */
    var flatpickr = require('flatpickr').default;
    var Korean = require('flatpickr/dist/l10n/ko.js').default.ko;

    $(document).ready(function () {
        $('input.app-date-text').each(function () {
            flatpickr(this, {
                dateFormat: 'Y-m-d',
                allowInput: true,
                locale: Korean,
                parseDate: function (dateStr) {
                    // 8자리 숫자 (YYYYMMDD) · Y-m-d → 브라우저 로컬 자정으로 변환
                    // (TASK-161 결정 28 보정 — new Date('Y-m-d') 는 UTC 자정 해석이라 UTC 보다 늦은 시간대 (미주 센터) 에서
                    //  기존 값이 하루 전으로 밀려 표시됨. cod-payment/date-input.js 와 동일 규칙)
                    var s = dateStr.replace(/\s/g, '');
                    var m = /^(\d{4})-?(\d{2})-?(\d{2})$/.exec(s);
                    if (m) {
                        return new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
                    }
                    return new Date(s);
                },
            });
        });
    });

})(jQuery);
